import React from 'react';
import PropTypes from 'prop-types';

export default function Tag(props) {
  // eslint-disable-next-line no-unused-vars
  const {
    tag,
    key,
    disabled,
    onRemove,
    classNameRemove,
    getTagDisplayValue,
    ...other
  } = props;

  return (
    <span key={key} {...other}>
      {tag.label}
      {!disabled && (
        <a className={classNameRemove} onClick={() => onRemove(key)} />
      )}
    </span>
  );
}

Tag.propTypes = {
  key: PropTypes.string,
  tag: PropTypes.object,
  disabled: PropTypes.bool,
  onRemove: PropTypes.func,
  classNameRemove: PropTypes.string,
  getTagDisplayValue: PropTypes.func,
};
